import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto">
          <div className="mb-10 text-center">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">常见问题</h2>
            <p className="text-foreground-500 text-sm mt-2">关于爆料网，你可能想了解的都在这里</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div key={idx} className="bg-background-50 rounded-lg border border-background-200/60 p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold flex-shrink-0 mt-0.5">Q</span>
                  <div>
                    <h3 className="text-base font-medium text-foreground-900 mb-2">{item.q}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}